import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=c97e960e&scoped=true"
import script from "./Timetable.vue?vue&type=script&lang=js"
export * from "./Timetable.vue?vue&type=script&lang=js"
import style0 from "./Timetable.vue?vue&type=style&index=0&id=c97e960e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97e960e",
  null
  
)

export default component.exports